export type LlmRuleData = {
  payeeName?: string;
  renamePayeeTo?: string;
  categoryName?: string;
  amount?: number;
  amountType?: 'INCOME' | 'EXPENSE';
  accountType?: 'BUSINESS' | 'PERSONAL';
  tags?: string[];
  memo?: string;
  markAsReviewed?: boolean;
  excludeFromReports?: boolean;
  excludeFromSpending?: boolean;
};

const normalizeOptionalString = (value?: string): string | undefined => {
  if (typeof value !== 'string') return undefined;
  const normalized = value.trim();
  return normalized.length > 0 ? normalized : undefined;
};

const normalizeOptionalStringArray = (values?: string[]): string[] | undefined => {
  if (!Array.isArray(values)) return undefined;

  const normalized = values.map((value) => normalizeOptionalString(value)).filter((value): value is string => !!value);

  return normalized.length > 0 ? normalized : undefined;
};

const normalizeAmount = (value?: number): number | undefined => {
  if (typeof value !== 'number' || !Number.isFinite(value) || value === 0) {
    return undefined;
  }

  return value;
};

const normalizeAccountType = (value?: string): LlmRuleData['accountType'] => {
  if (value === 'BUSINESS' || value === 'PERSONAL') {
    return value;
  }

  return undefined;
};

const normalizeTruthyBoolean = (value?: boolean): true | undefined => {
  return value === true ? true : undefined;
};

export const normalizeLlmRuleData = (data: LlmRuleData): LlmRuleData => {
  const amount = normalizeAmount(data.amount);

  return {
    payeeName: normalizeOptionalString(data.payeeName),
    renamePayeeTo: normalizeOptionalString(data.renamePayeeTo),
    categoryName: normalizeOptionalString(data.categoryName),
    amount,
    amountType: amount !== undefined ? data.amountType : undefined,
    accountType: normalizeAccountType(data.accountType),
    tags: normalizeOptionalStringArray(data.tags),
    memo: normalizeOptionalString(data.memo),
    markAsReviewed: normalizeTruthyBoolean(data.markAsReviewed),
    excludeFromReports: normalizeTruthyBoolean(data.excludeFromReports),
    excludeFromSpending: normalizeTruthyBoolean(data.excludeFromSpending),
  };
};
